// @ts-nocheck
import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { useAuth } from "@/components/layout/AuthProvider"
import { PostCard } from "@/components/post/PostCard"

export default function BookmarksPage() {
  const { supabaseUser } = useAuth()
  const [posts, setPosts] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!supabaseUser) return
    supabaseClient.from("bookmarks")
      .select("posts(*, users!posts_author_id_fkey(id,username,display_name,avatar_url,is_verified), post_topics(topics(id,name,slug)))")
      .eq("user_id", supabaseUser.id)
      .order("created_at", { ascending: false })
      .then(({ data }) => {
        setPosts((data || []).map((b: any) => ({ ...b.posts, author: b.posts?.users, topic: b.posts?.post_topics?.[0]?.topics })).filter(Boolean))
        setLoading(false)
      })
  }, [supabaseUser?.id])

  if (!supabaseUser) return <Navigate to="/auth/login" replace />

  return (
    <div className="container-narrow py-4 pb-20 lg:pb-4">
      <h1 className="font-syne font-bold text-xl mb-4">Saved</h1>
      {loading ? (
        <div className="space-y-2">{[1,2,3].map(i => <div key={i} className="skeleton h-24 rounded" />)}</div>
      ) : posts.length === 0 ? (
        <div className="panel p-12 text-center"><p className="font-syne font-bold text-lg mb-1">Nothing saved yet</p><p className="text-sm text-muted-fg">Hit Save on any post to find it here.</p></div>
      ) : (
        <div className="space-y-2">{posts.map(p => <PostCard key={p.id} post={p} userId={supabaseUser.id} />)}</div>
      )}
    </div>
  )
}
